/**
 * Cache mémoire pour les URLs des voice messages — Phase 2,
 * incrément 2.3.
 *
 * Jumeau de `photoUrls.ts`, basé sur le même factory
 * `createBlobUrlCache('voice')`. Sémantique identique :
 *
 *   - `setVoiceUrl(msgId, url)` : pose immédiate, typiquement après
 *     `MediaRecorder.onstop` → `URL.createObjectURL(blob)` →
 *     `addMessage({ audioUrl: url })`. L'utilisateur peut lire le
 *     message qu'il vient d'enregistrer sans round-trip IDB.
 *   - `getVoiceUrlNow(msgId)` : retourne le cache ou lazy-load
 *     depuis IDB (clé `voice:<msgId>`). Pendant l'hydratation,
 *     l'élément `<audio>` reçoit `src=""` et le bouton play est
 *     temporairement inerte. À la résolution, `bumpUi()` re-render
 *     et `<audio>` reçoit la blob: URL.
 *   - `clearVoiceUrl(msgId)` : révoque la blob: URL côté navigateur.
 *
 * Voir `blobUrls.ts` pour le détail de la factory.
 */
import { createBlobUrlCache } from './blobUrls.js';

const cache = createBlobUrlCache('voice');

export function setVoiceUrl(msgId: string, url: string): void {
  cache.setUrl(msgId, url);
}

export function getVoiceUrlNow(msgId: string): string | null {
  return cache.getUrlNow(msgId);
}

export function clearVoiceUrl(msgId: string): void {
  cache.clearUrl(msgId);
}

/** @internal pour tests — purge complète. */
export function _resetVoiceUrlsForTests(): void {
  cache.reset();
}

/** @internal pour tests — vérifie si une URL est cachée. */
export function _hasCachedVoiceUrl(msgId: string): boolean {
  return cache.has(msgId);
}
